module.exports = __webpack_public_path__ + "static/chafik-0bb7795d024f69b36d442c2e8d0ca8aa.jpg";